import constate from 'constate';

export interface UseFilesServiceProps {
  filesServiceDomain: string;
}

const useFilesService = ({ filesServiceDomain }: UseFilesServiceProps) => {
  return { filesServiceDomain };
};

export const [FilesServiceProvider, useFilesServiceContext] =
  constate(useFilesService);
